import gql from 'graphql-tag'

export default gql`
query listUserLoyaltyCardBills($userId: ID!, $params: ListQueryArgs, $filter: BillFilterArgs) {
	cashAssist {
		listUserLoyaltyCardBills(userId: $userId, params: $params, filter: $filter) {
			items {
				id
				dateTime
				date
				number
				isCancelled
				cashRegister {
					name
				}
				items {
					flag
					mul1
					amount
					price
					total
					codeMWSt
					product {
						code
						name
					}
					discountPercent,
					inCafe
				}
				total
			}
			cursors {
				hasNext
				hasPrevious
				before
				after
			}
		}
	}
}
`
